window.zh_TW_dic = {
    'plan':'計劃',
    'common.calendar.january': '一月',
    'common.calendar.february': '二月',
    'common.calendar.march': '三月',
    'common.calendar.april': '四月',
    'common.calendar.may': '五月',
    'common.calendar.june': '六月',
    'common.calendar.july': '七月',
    'common.calendar.august': '八月',
    'common.calendar.september': '九月',
    'common.calendar.october': '十月',
    'common.calendar.november': '十一月',
    'common.calendar.december': '十二月',
    'common.calendar.sunday.short': '日',
    'common.calendar.monday.short': '一',
    'common.calendar.tuesday.short': '二',
    'common.calendar.wednesday.short': '三',
    'common.calendar.thursday.short': '四',
    'common.calendar.friday.short': '五',
    'common.calendar.saturday.short': '六',
    'common.label.roomCount': '房間',
    'common.label.mailAddressEmptyError': '請輸入您的電子郵件地址。',
    'common.label.mailAddressCharacterCountError': '請在 254 個字符內輸入您的電子郵件地址。',
    'common.label.mailAddressIncorrectError': '請輸入正確的電子郵件地址。',
    'GCER001F00100.label.countryCodeEmptyError': '請輸入您的聯繫信息（國家代碼）。',
    'GCER001F00100.label.countryCodeCharacterCountError': '請在 5 個字符內輸入聯繫信息（國家代碼）。',
    'GCER001F00100.label.countryCodeIncorrectError': '請輸入正確的聯繫信息（國家代碼）。',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin5': '請輸入5個字符以內的聯繫方式（區號）。',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin9': '請輸入9個字符以內的聯繫方式（區號）。',
    'common.label.areaCodeIncorrectError': '請輸入正確的聯繫方式（區號）。',
    'common.label.cityCodeCharacterCountErrorWithin4': '請在 4 個字符內輸入聯繫信息（城市代碼）。',
    'GCER001F00100.label.cityCodeCharacterCountErrorWithin9': '請在 9 個字符內輸入聯繫信息（城市代碼）。',
    'common.label.cityCodeIncorrectError': '請輸入正確的聯繫方式（城市代碼）。',
    'common.label.subscriberNumberCharacterCountErrorWithin4': '請輸入 4 個字符以內的聯繫信息（訂閱者號碼）。',
    'GCER001F00100.label.subscriberNumberCharacterCountErrorWithin9': '請輸入 9 個字符以內的聯繫信息（訂閱號）。',
    'common.label.subscriberNumberIncorrectError': '請輸入正確的聯繫信息（訂戶號碼）。',
    'GCER001F00100.label.areaCodeEmptyError': '請輸入您的聯繫信息（區號）。',
    'GCER001F00100.label.cityCodeEmptyError': '請輸入聯繫方式（城市代碼）。',
    'GCER001F00100.label.subscriberNumberEmptyError': '請輸入您的聯繫信息（訂戶號碼）。',
    'common.label.reservationNumberEmptyError': '請輸入您的預訂號碼。',
    'common.label.reservationNumberCharacterCountError': '請在 19 個字符內輸入預訂編號。',
    'common.label.passwordEmptyError': '請輸入您的密碼。',
    'common.label.passwordCharacterCountError': '輸入最多 64 個字符的密碼。',
    'common.label.authenticationError': '執行身份驗證時出錯。請重新加載身份驗證屏幕並再次執行身份驗證。',
    'common.label.snsAuthenticationFail': 'SNS 身份驗證失敗。',
    'GCER001F00100.label.failSnsLogin': '登錄 SNS 失敗。',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin3': '請輸入3個字符以內的聯繫方式（區號）。',
    'common.label.unexpectedLoginError': '登錄時發生意外錯誤。',
    'common.label.sun': '日',
    'common.label.mon': '一',
    'common.label.tue': '二',
    'common.label.wed': '三',
    'common.label.thu': '四',
    'common.label.fri': '五',
    'common.label.sat': '六',
    'common.label.gender.male': '男士',
    'common.label.gender.female': '女士',
    'common.label.gender.other': '其他',
    'common.label.adult':'成人',
    'common.label.guestCount': '人',
    'common.label.comma': '、',
    'common.label.others':'其他',
    'common.label.yen': '日元',
    'common.label.paymentFailMessage': '支付失敗。請聯繫您的系統管理員。',
    'common.label.mailAddressIncorrectFormatError': '請以正確的電子郵件地址格式輸入您的電子郵件地址。',
    'common.label.welcomeInformation1-1': '歡迎電子郵件是提醒您的電子郵件',
    'common.label.welcomeInformation1-2': '您入住前一周的預訂。',
    'common.label.welcomeInformation2': '* 但是，類似的電子郵件將在您入住前 3 天發送。',
    'common.label.welcomeInformation3': '請注意，您的電子郵件將始終發送給您。',
    'common.label.thankYouInformation': '感謝電子郵件是您入住後發送的電子郵件。',
    'common.label.chargeDetails': '收費詳情',
    'common.label.nightNumber': '晚',
    'common.label.roomNumber': '房間',
    'common.label.memberDiscount': '會員折扣',
    'common.label.subtotal': '小計',
    'common.label.totalRoomRate': '總額',
    'common.label.pointYenEquivalent': '積分',
    'common.label.pointBalanceAmount': '可用積分',
    'common.label.usableMaxLimit.point': '使用上限爲{0}點',
    'common.label.usableMinLimit.point': '使用下限爲{0}點',
    'common.label.usableRange.point': '可使用{0}-{1}積分。',
    'common.label.pointToGrantSuffix.point': '{0} 積分',
    'common.label.usableUnit.point': '(使用單位爲{0}點)',
    'common.label.usableUnit.point.help': '可以{0}點爲單位使用。',
    'common.label.use': '使用',
    'common.label.useAll': '全部使用',
    'coupon.message.applyCode' : '額外優惠券。',
    'coupon.message.getCoupon' : '得到一張優惠券。',
    'coupon.message.getCoupon.failed' : '無法獲得優惠券。',
    'GRES006F02600.label.lodgingNumChangeCautionWord': '* 人數不能加。如果您想添加它，請再次預訂。',
    'GRES006F02600.label.lodgingNumPriceEmptyCautionWord': '不能接受您指定的客人總數的預訂。',
    'GRES006F02600.label.lodgingDateNumChangeCautionWord': '* 您不能增加住宿天數。如果您想增加它，請再次預訂。',
    'GRES006F02600.label.optionChangeWord': '*無法選擇，因為它超出了預訂接受期限',
    'GRES006F02600.label.kanaInformation': '請輸入平假名。',
    'GRES006F02600.label.mailInformation1': '請在兩個地方輸入相同的電子郵件地址以防止輸入錯誤。',
    'GRES006F02600.label.mailInformation2': '如果您輸入您的移動電子郵件地址，請注意您的電子郵件過濾器設置。',
    'GRES006F02600.label.mailInformation3': '如果您設置為無法接收來自互聯網的電子郵件，您將無法收到確認預訂的電子郵件。',
    'GRES006F02600.label.contactInformation': '請只輸入半角數字。',
    'common.label.addressZipMark': '',
    'GRES015F04300.label.reservationAcceptanceSuspension':'抱歉。目前，我們不接受預訂。',
    'GRES015F04300.label.planAcceptanceSuspension': '抱歉。目前，我們不接受指定的計劃。',
    'GRES015F04300.label.roomAcceptanceSuspension': '抱歉。目前，指定房間的接待處已關閉。',
    'GRES001F02100.label.returnPlanList' : '返回計劃列表',
    'GRES001F02100.validation.emptyNameError' : '姓名為必填項，請輸入。',
    'GRES001F02100.validation.wrongNameError' : '輸入時請排除特殊符號和依賴環境的字符。',
    'GRES001F02100.validation.emptyNameKanaError' : '',
    'GRES001F02100.validation.wrongNameKanaError' : '',
    'GRES001F02100.validation.emptyMailAddressError' : '電子郵件地址為必填項，請輸入。',
    'GRES001F02100.validation.wrongMailAddressError' : '請以有效格式輸入。',
    'GRES001F02100.validation.emptyMailAddressConfirmError' : '電子郵件地址為必填項，請輸入。',
    'GRES001F02100.validation.unmatchMailAddressConfirmError' : '請輸入一個匹配的電子郵件地址。',
    'GRES001F02100.validation.emptyTelError' : '電話號碼為必填項，請輸入半型數字。',
    'GRES001F02100.validation.wrongTelError' : '請輸入半型數字。',
    'GRES001F02100.validation.tooShortTelAreaError' : '請輸入2到5個單字節數字的區號。',
    'GRES001F02100.validation.tooLongTelError' : '請輸入7到15個單字節數字。',
    'GRES001F02100.validation.emptyLodgerGender' : '性別為必填項。',
    'GRES001F02100.validation.emptyPassword' : '密碼為必填項。請設置8至64個半型的字母及數字（包括大寫和小寫字母）。',
    'GRES001F02100.validation.wrongPassword' : '請設置8至64個半型的字母數字字符（包括大寫和小寫字母）。',
    'GRES001F02100.validation.emptyBirthday' : '出生日期為必填項。',
    'GRES001F02100.validation.notRequiredEmptyBirthday' : '請選擇您的出生日期。',
    'GRES001F02100.validation.emptyZipCode' : '郵政編碼是必填字段。請輸入半型數字。',
    'GRES001F02100.validation.wrongZipCode' : '請輸入半型數字。',
    'GRES001F02100.validation.emptyAddressPrefectures' : '地址為必填項。',
    'GRES001F02100.validation.emptyAddress' : '地址為必填項，請輸入。',
    'GRES001F02100.validation.emptyCreditCardNo' : '信用卡卡號為必填項，請輸入14-16位的半型數字。',
    'GRES001F02100.validation.wrongCreditCardNo' : '請輸入14-16個半型數字。',
    'GRES001F02100.validation.emptySecurityCode' : '安全碼為必填項。請輸入3或4個半型數字。',
    'GRES001F02100.validation.wrongSecurityCode' : '請輸入3或4個半型數字。',
    'GRES001F02100.validation.emptyCreditCardName' : '持卡人姓名為必填項，請輸入。',
    'GRES001F02100.validation.wrongCreditCardName' : '請輸入有效的持卡人姓名。',
    'GRES001F02100.validation.emptyCreditCardExpire' : '信用卡到期日為必填項，請選擇。',
    'GRES001F02100.validation.wrongCreditCardExpire' : '將會選擇過去的日期。請選擇一個未來的日期。',
    'GRES001F02100.validation.tooLongTextArea' : '請輸入200個字符以內。',
    'GRES001F02100.validation.emptyContractCompany' : '此欄爲必填項。請輸入。',
    'GRES001F02100.validation.emptyContractCompanyPassword' : '密碼為必填項。請輸入。',
    'GRES001F02100.validation.wrongContractCompanyPassword' : '請輸入半角字母數字符號。',
    'GRES001F02100.validation.unmatchLodgerGender' : '請選擇與您的預訂相匹配的人數。',
    'GRES001F02100.validation.emptyQuestionTextAnswer' : '此欄爲必填項。請輸入。',
    'GRES001F02100.validation.tooLongQuestionTextAnswer' : '請輸入200個字符以內。',
    'GRES001F02100.validation.emptyQuestionSelectAnswer' : '此爲必填項，請選擇。',
    'GRES001F02100.validation.emptyQuestionCheckboxAnswer' : '此爲必填項，請選擇。',
    'GRES001F02100.validation.couponCodeError' : '找不到輸入代碼的優惠券。 請確認輸入的內容。',
    'GRES001F02100.validation.couponCodeDuplicatedError' : '優惠券已經添加。',

    'coupon.label.more': '更多信息▼',
    'coupon.label.close': '更多信息▲',

    'coupon.banner.title.member': '註冊成爲會員，',
    'coupon.banner.title': '用折扣優惠券省錢!',
    'coupon.banner.title.button': '欲瞭解更多信息 ▶',
    'coupon.modal.title': '註冊成爲會員，可享受特別優惠券',
    'coupon.modal.title.member': '正在分發的優惠券清單',
    'coupon.modal.caution': '每張優惠券都有自己的獲取和使用條件。',
    'coupon.modal.desc.1': '優惠券的折扣適用於房費。折扣不適用於額外的可選費用。',
    'coupon.modal.desc.2': '你所獲得的優惠券會在預訂時自動應用於最佳交易和組合。',
    'coupon.modal.desc.3': '如果計劃發放的優惠券數量結束，或由於預算或其他原因，優惠券可能提前結束。',
    'coupon.modal.desc.4': '據預訂的時間，即使已經獲得，也可能無法使用。',
    'coupon.modal.membership': '如果你已經註冊了',
    'coupon.modal.memberLogin': '請登錄',
    'coupon.modal.memberRegister': '註冊成爲會員',
    'coupon.modal.has.otherCoupons': '可在其他日期使用的優惠券',
    'coupon.badge.couponTarget': '優惠券的使用資格',
    'coupon.badge.banner.title': '賺取省錢的優惠券',

    'coupon.label.code': '（{{code}}）',
    'coupon.label.discountAmount.upper': '從預訂的總金額中扣除',
    'coupon.label.discountAmount.upper_false': '每人或每間房',
    'coupon.label.discountAmount': '{{amount, number}}日元的折扣',
    'coupon.label.discountAmount_rate': '{{amount, number}}％折扣',
    'coupon.label.discountAmount.has.zeroDiscount': '優惠',
    'coupon.label.canUseTogether_true': '可與其他優惠券一起使用',
    'coupon.label.canUseTogether_false': '不可與其他優惠券同時使用',
    'coupon.label.discountLimit': '最高折扣爲{{amount, number}}日元。',
    'coupon.label.discountLimit_plan': '最高折扣爲每人每晚{{amount, number}}日元。',
    'coupon.label.fromTotalBookings.not': '* 根據不同的計劃，折扣來自於每人每晚的房價或每間房每晚的房價。',
    'coupon.label.useQuantityLimit': '先到先得使用{{amount, number}}張爲止',
    'coupon.label.targetPlans': '合格的計劃：',
    'coupon.label.availableMonths': '自獲得之日起{{months}}個月',
    'coupon.label.expiredAt': '過期日期:',
    'coupon.label.neverExpires': '無有效日期',
    'coupon.label.stayAt': '住宿所涵蓋的時期：',
    'coupon.label.periodRange': '{{- day.start}}～{{- day.end}}',
    'coupon.label.periodRangeCheck': '{{- day.start}}報到～{{- day.end}}退房',
    'coupon.label.unavailableDays': '不包括的日子：',
    'coupon.label.unavailablePeriod': '排除期:',
    'coupon.label.useCondition': '可用於{{amount, number}}日元以上的預訂',
    'coupon.label.remainingTimes': '最多可以使用{{amount, number}}次（剩餘{{remains, number}}次）',
    'coupon.label.remainingTimes.limit': '最多可以使用{{amount, number}}次',
    'coupon.label.remainingTimes.one': '僅有一次機會',
    'coupon.label.remainingTimes.noLimit': '只要你願意，可以多次使用',
    'coupon.label.acquired': '已經獲得',
    'coupon.label.acquiring': '獲得',
    'coupon.message.unable.useAmountLimit' : '由於競選活動已經結束，所以無法獲得。',
    'coupon.message.unable.useQuantityLimit' : '由於競選活動已經結束，所以無法獲得。',
    'coupon.message.unable.ended' : '由於競選活動已經結束，所以無法獲得。',
    'coupon.message.unable.notApplied' : '不能與預定使用的優惠券一起使用。',

    'common.message.temporaryError': '發生臨時錯誤。 請重新載入頁面以刷新。',
    'common.label.required': '必須',
};
